import React from 'react';

import Error from '@/components/Error/Error';
import MenuHeader from '@/components/Header/MenuHeader';
import { ErrorCircleIcon } from '@/components/Icon';
import { colors } from '@/const/colors/index';

const NotFoundPage = () => {
  return (
    <>
      <MenuHeader title="" />
      <div className="w-full flex flex-col justify-center items-center h-screen">
        <Error
          icon={<ErrorCircleIcon color={colors.gray[5]} width={144} height={144}></ErrorCircleIcon>}
          title="찾을 수 없는 페이지입니다"
          description="잘못된 링크입니다.<br/>정상적인 링크로<br/>다시 시도해주세요."
        />
      </div>
    </>
  );
};

export default NotFoundPage;
